<template>
  <div class="template_wrapper">
    <span class="template_title" style="vertical-align: middle">
      {{moduel.name}}
      <span
        style="color:red;vertical-align: top;"
        v-if="moduel.required==1&& type=='audit'"
      >*</span>
    </span>
    <el-select
      v-model="options"
      filterable
      default-first-option
      :filter-method="filenameInput"
      @change="nameSelected"
      placeholder="请输入文件名称从上传文件中搜索文件"
    >
      <el-option
        v-if="files_in_use.indexOf(item.id) == -1"
        v-for="item in files"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      ></el-option>
    </el-select>
    <span style="color:red;vertical-align: top;" v-if="moduel.required==1&& type!='audit'">*</span>

    <div class="upload_wrapper">
      <el-upload
        class="upload-demo"
        :on-success="add_document_success"
        :action="upload_url"
        :show-file-list="false"
        ref="upload_approval"
        name="file"
        :on-change="change_add_document"
        :auto-upload="true"
        :data="upload_file_data"
        :file-list="fileList_approval"
        :limit="limit"
      >
        <span style="color: #0099CC;">点击上传新文件</span>
        <!-- <span>(温馨提示：支持上传word、excel、ppt、pdf、图片)</span> -->
      </el-upload>
    </div>

    <div style="margin-top: 10px;width:60%;padding:0 0 0 100px;" v-if="files_names.length > 0">
      <!-- <span>流程:</span> -->
      <span v-for="(item,key) in files_names" :key="key" style="margin:  10px;">
        <span class="userSelected">
          {{item}}
          <span class="user_del" @click="del_file(key)" style="white-space:nowrap;">
            <img src="../assets/del_icon.png" alt />
          </span>
        </span>
      </span>
    </div>
  </div>
</template>
<!--:filter-method="filenameInput"-->
<style scoped>
.el-input {
  width: auto !important;
}
.files .el-select {
  width: 80%;
}
.upload_wrapper {
  padding-left: 100px;
  padding-right: 10px;
  text-align: left;
}
.user_del {
  display: inline-block;
}
.user_del img {
  height: auto;
  width: 18px;
  /* line-height: 18px; */
  /* border-radius: 30px; */
  /* background: #ccc; */
  /* color: #fff; */
  margin: 0 0 0 8px;
  cursor: pointer;
  vertical-align: middle;
}
.userSelected {
  text-align: center;
  line-height: 30px;
  height: 30px;
  padding: 0 10px;
  border-radius: 3px;
  margin-right: 10px;
  background: #f2f3f5;
  display: inline-block;
  color: #333;
}
</style>
<script>
// import store from '@/vuex/store.js';
export default {
  name: "selectObj",
  data() {
    return {
      options: "",
      files_names: [],
      staff: "",
      keyword: "",
      clearable: false,
      web_token: "",
      web_url: "",
      upload_url: "",
      limit: 1,
      upload_file_data: {},
      fileList_approval: [],
      files: [],
      files_in_use: []
    };
  },
  // store,
  props: ["moduel", "projectData", "input_callback"],
  methods: {
    filenameInput: function(query) {
      this.files = [];
      if (query == "") {
        return false;
      }
      this.$http
        .post(
          this.web_url + "/document",
          { web_token: this.web_token, keyword: query, my_create: true },
          { emulateJSON: true }
        )
        .then(function(res) {
          // console.log(this.templates);
          if (res.data.status == "ok") {
            this.files = res.data.data.list;
            //                console.log(this.user_list )
          } else {
          }
        })
        .catch(function(res1) {
          console.log(res1);
        });
    },
    nameSelected: function() {
      if (this.options == "") {
        return false;
      }
      for (var i = 0; i < this.files.length; i++) {
        var _item = this.files[i];
        if (this.options == _item.id) {
          this.files_names.push(_item.name);
          this.files_in_use.push(_item.id);
        }
      }

      this.input_callback(this.files_in_use);
      console.log(this.files_in_use);
      this.options = "";
      // this.$emit('input', this.files_in_use);
      // console.log(this.files_in_use)
      // console.log(this.projectData)
      // this.options = '';
      // this.$emit('listenToChildEvent');
    },
    del_file: function(key) {
      this.files_names.splice(key, 1);
      this.files_in_use.splice(key, 1);
      this.input_callback(this.files_in_use);
      // this.$emit('listenToChildEvent');
    },
    // removeUser(id){
    //   this.$emit('input', this.options);
    // },
    //获取i项目人员名字
    get_files: function() {
      //获取文件
      this.$http
        .post(
          this.web_url + "/document",
          {
            web_token: this.web_token,
            keyword: "",
            my_create: true,
            limits: 1000
          },
          { emulateJSON: true }
        )
        .then(function(res) {
          if (res.data.status == "ok") {
            this.files = res.data.data.list;
          } else {
          }
        })
        .catch(function(res1) {
          console.log(res1);
        });
    },
    change_add_document: function() {
      this.upload_file_data.web_token = this.web_token;
    },
    add_document_success: function(data) {
      this.fileList_approval = [];
      // this.files.push(data.data);
      // this.approval_data.document_ids.push(data.data.id);
      this.files_names.push(data.data.name);
      this.files_in_use.push(data.data.id);
      this.input_callback(this.files_in_use);
    }
  },
  mounted() {
    console.log(this.projectData[this.moduel.key_name]);
    //  this.options = this.projectData[this.moduel.key_name];
  },
  created() {
    this.web_token = sessionStorage.getItem("web_token");
    this.web_url = sessionStorage.getItem("web_url");
    this.upload_url = this.web_url + "/document/add";
    // this.get_files();
  },
  computed: {},
  watch: {
    options: {
      handler(newName, oldName) {
        //  this.$emit('input',this.options);
      },
      immediate: true,
      deep: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/filelist_multiple.vue